// ToDo loadMasking is used via a global created by the module
// eslint-disable-next-line no-unused-vars
import { format, locale, util } from '@glu/core';
import FlexDropdown from '@glu/flex-dropdown';
import template from './amountSearch.hbs';
import FieldSearch from './fieldSearch';

import './loadMasking';

const operatorMap = {
  EQ: '=',
  LT: '<',
  LTEQ: '<=',
  GT: '>',
  GTEQ: '>=',
  BETWEEN: 'in between'
};

export default FieldSearch.extend({
  template,

  ui: util.extend({}, FieldSearch.prototype.ui, {
    $fieldSelect: 'select',
    $fieldOperator: 'select[name="field-equality"]',
    $fieldValue2: 'input[name="field-value2"]',
    $operandContainer: '.search-operand-container'
  }),

  regions: {
    fieldEquality: '.region-field-equality'
  },

  handleOpSelection(ids) {
    const operator = ids[0];
    const isBetween = operator === 'BETWEEN';

    this.ui.$operandContainer.toggleClass('range-input', isBetween);
    this.ui.$fieldValue.attr('placeholder', isBetween ? 'start' : '');
  },

  onRender() {
    FieldSearch.prototype.onRender.call(this);
    this.showDropdown();
    this.ui.$focusField.maskAmount();
  },

  onClose() {
    this.ui.$focusField.unmask();
  },

  createDropdown() {
    const data = this.getDropDownData();
    const flexDropdownOptions = {
      data,
      filter: false,
      multiSelect: false,
      preSelectedIds: this.model && this.model.get('equality') ? [this.model.get('equality')] : [data[0].id],
      showTooltip: false,
      showCancelIcon: false,
      clearBtn: false,
      disableMultiButton: true
    };

    const dropdown = new FlexDropdown(flexDropdownOptions);

    this.listenTo(dropdown, 'selectionChanged:id', this.handleOpSelection);

    return dropdown;
  },

  getDropDownData() {
    return [{
      id: 'EQ',
      name: locale.get('filter.equal')
    }, {
      id: 'LT',
      name: locale.get('filter.less')
    }, {
      id: 'LTEQ',
      name: locale.get('filter.less.or.equal')
    }, {
      id: 'GT',
      name: locale.get('filter.greater')
    }, {
      id: 'GTEQ',
      name: locale.get('filter.greater.or.equal')
    }, {
      id: 'BETWEEN',
      name: locale.get('filter.between')
    }];
  },

  onBeforeRender() {
    this.initializeDropdown();
  },

  initializeDropdown() {
    if (this.dropdown) {
      this.dropdown.close();
    }
    this.dropdown = this.createDropdown();
  },

  showDropdown() {
    this.fieldEquality.show(this.dropdown);
  },

  templateHelpers() {
    const equality = this.model ? this.model.get('equality') : '';
    return {
      cid: this.cid,
      isOpBetween: equality === 'BETWEEN'
    };
  },

  handleSubmit(e) {
    e.preventDefault();

    if (!this.model.isValid()) {
      return false;
    }

    const equality = this.dropdown.value('id')[0];
    const value = this.ui.$fieldValue.val();
    const value2 = this.ui.$fieldValue2.val();

    const filter = this.buildFilter(value, equality, value2);
    try {
      this.trigger('filter', filter);
    } catch (ex) {
      return false;
    }
    return false;
  },

  filter(field, value, equality, model) {
    switch (equality) {
      case 'BETWEEN':
        return model.get(field) >= util.min(value) && model.get(field) <= util.max(value);
      case 'LT':
        return model.get(field) < value;
      case 'LTEQ':
        return model.get(field) <= value;
      case 'GT':
        return model.get(field) > value;
      case 'GTEQ':
        return model.get(field) >= value;
      default:
        return model.get(field) === value;
    }
  },

  createFilter() {
    return this.buildFilter(this.ui.$focusField.get(0).value, this.dropdown.value('id')[0], this.ui.$focusField.get(1).value);
  },

  buildFilter(value, equality, value2) {
    const filterOutput = {
      field: this.field,
      title: this.model.get('title'),
      type: this.model.get('type')
    };

    switch (equality) {
      case 'BETWEEN':
        filterOutput.equality = equality;
        filterOutput.label = `${operatorMap[equality]} ${value} - ${value2}`;
        filterOutput.value = [format.removeNumberFormat(value), format.removeNumberFormat(value2)];
        break;

      default:
        filterOutput.equality = equality || 'EQ';
        filterOutput.label = `${operatorMap[equality]} ${value}`;
        filterOutput.value = [format.removeNumberFormat(value)];
        break;
    }

    filterOutput.filter = util.bind(this.filter, this, this.field, filterOutput.value, equality);
    return filterOutput;
  }
});
